/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { PortalShadeOption } from "../../Store/entities/assemblies/types";
import { GroupHeader, OptionLabel } from "../../Parts/FormParts";
import ColorOptionsAccordion from "./ColorOptionsAccordion";

type ColorPaletteModalProps = {
	colors: PortalShadeOption<string>[];
	colorPalettes: PortalShadeOption<string>;
	errorClass: (option: PortalShadeOption<any>) => "border border-danger" | "";
	quoteType: string;
	highlightSharedValues?: boolean;
};

const ColorPaletteModal = ({
	colors,
	colorPalettes,
	errorClass,
	quoteType,
	highlightSharedValues = false,
}: ColorPaletteModalProps) => {
	const { value: colorPaletteValue } = colorPalettes.getSelectedOption();
	
	const [palettesState, setPalettesState] = useState(colorPalettes);

	const buildClassName = (...classes: string[]) => classes.filter(Boolean).join(" ");
	const sharedHighlightClass = (option: PortalShadeOption<any>) => {
		if (!highlightSharedValues || !option?.getValue) return "";
		const value = option.getValue();
		if (value === null || value === undefined) return "";
		if (typeof value === "string" && value.trim() === "") return "";
		return "border border-2 border-primary rounded";
	};

	useEffect(() => {
		const initialPalettes = palettesState;
		setPalettesState(colorPaletteValue === "Custom Palette" ? initialPalettes : colorPalettes);
	}, [colorPaletteValue]);

	const baseErrorClass = errorClass(colorPalettes);
	const baseHighlightClass = sharedHighlightClass(colorPalettes);
	const baseCombinedClassName = buildClassName(baseErrorClass, baseHighlightClass);
	const mismatchedLabel = highlightSharedValues ? "Mismatched Colors" : undefined;
	
	return (
		<Col className="color-palette-modal">
			{GroupHeader("Base Color Palette", quoteType)}

			<Row className="p-2">
				{OptionLabel(colorPalettes, false)}
				<ColorOptionsAccordion
					title="Base Color Palette"
					options={
						(palettesState.options || colorPalettes.options || [])
							.filter((palette) => palette.value !== "Custom Palette") as { value: string }[]
					}
					selectedOption={palettesState.getSelectedOption()}
					onSelect={(value) => colorPalettes.setValue(value)}
					colorPalettes={colorPalettes}
					className={baseCombinedClassName}
					hasSharedValue={baseHighlightClass !== ""}
					mismatchedLabel={mismatchedLabel}
				/>
			</Row>
			{GroupHeader("Color Overrides", quoteType)}
			{colors
				.filter((color) => color.label !== "Not Set")
				.sort((a, b) => a.label.localeCompare(b.label))
				.map((color) => {
					const defaultColor = palettesState.getSelectedOption().default_colors?.[color.label];
					const errorClassForOption = errorClass(color);
					const highlightClassForOption = sharedHighlightClass(color);
					const overrideClass = palettesState.getValue() !== "Custom Palette"
						&& defaultColor
						&& defaultColor !== "Missing Default Color"
						&& color.getValue() !== defaultColor
						? "border-primary border-3 rounded-3"
						: "";
					const combinedClassName = buildClassName(
						errorClassForOption,
						highlightClassForOption,
						overrideClass,
					);
					return <Row key={color.varName} className="p-2">
						{OptionLabel(color, false)}
						<ColorOptionsAccordion
							title={color.varName}
							defaultColor={defaultColor as string}
							options={color.options || []}
							selectedOption={color.getSelectedOption()}
							onSelect={color.setValue}
							colorPalettes={palettesState}
							className={combinedClassName}
							hasSharedValue={highlightClassForOption !== ""}
							mismatchedLabel={mismatchedLabel}
						/>
					</Row>;
				})}

		</Col>
	);
};

export default ColorPaletteModal;
